import { render, staticRenderFns } from "./WorkplaceCreateForm.vue?vue&type=template&id=7a709ac4&"
import script from "./WorkplaceCreateForm.vue?vue&type=script&lang=js&"
export * from "./WorkplaceCreateForm.vue?vue&type=script&lang=js&"
import style0 from "./WorkplaceCreateForm.vue?vue&type=style&index=0&id=7a709ac4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports